<template>
  <section class="section-block" v-loading="loading">
    <div class="section-title">第二步：预检并确认异常</div>

    <div class="status-cards">
      <div class="status-card warning">
        <div class="card-title">处理目标</div>
        <div class="card-value">{{ displayValue(planStatistics.targetNum) }}</div>
      </div>
      <div class="status-card danger">
        <div class="card-title">预计输出</div>
        <div class="card-value">{{ displayValue(planStatistics.outputNum) }}&nbsp;<span class="card-title">个文件</span></div>
      </div>
      <div class="status-card success">
        <div class="card-title">规则已冻结</div>
        <div class="card-value">{{ displayValue(planStatistics.frozenNum) }}&nbsp;<span class="card-title">套</span></div>
      </div>
      <div class="status-card success">
        <div class="card-title">规格映射</div>
        <div class="card-value">{{ displayValue(planStatistics.mapNum) }}&nbsp;<span class="card-title">项</span></div>
      </div>
    </div>

    <div>
      <div class="content-panel">
        <div class="mini-title">处理计划与源素材校验</div>
        <el-table
          :data="planRows"
          border
          size="mini"
          :header-cell-style="{ backgroundColor: '#FAFAFA', textAlign: 'center' }"
          :cell-style="{ textAlign: 'center' }"
          height="240"
        >
          <el-table-column prop="storeName" label="店铺" width="120" show-overflow-tooltip />
          <el-table-column prop="categoryName" label="适用规则分类" width="120" show-overflow-tooltip />
          <el-table-column prop="type" label="素材类型" width="120" show-overflow-tooltip />
          <el-table-column prop="currentVersion" label="规则" width="120" show-overflow-tooltip />
          <el-table-column prop="srcParam" label="源素材实际参数" width="140" show-overflow-tooltip />
          <el-table-column prop="processMode" label="处理方式" width="120" show-overflow-tooltip />
          <el-table-column prop="outputReq" label="输出要求" width="120" show-overflow-tooltip />
          <el-table-column prop="replacePosition" label="替换位置" width="120" show-overflow-tooltip />
          <el-table-column prop="conclusion" label="校验结论" width="120" show-overflow-tooltip />
          <el-table-column prop="checkStatus" label="校验状态" width="100" show-overflow-tooltip />
          <el-table-column prop="outputFileNum" label="预计输出文件" width="110" />
        </el-table>
        <el-checkbox v-model="tableChecked">排除清仓商品规格</el-checkbox>
      </div>

      <div class="content-panel">
        <div class="mini-title">人工检查项</div>
        <div class="code-box">{{ confirmText }}</div>
        <el-checkbox v-model="exceptionConfirmed" @change="handleExceptionConfirmChange">确认已完成上述人工检查</el-checkbox>
      </div>
    </div>
  </section>
</template>

<script>
const mockPlanRows = [
  {
    storeName: '天猫二店',
    categoryName: '卖点主图规范',
    type: '主图',
    currentVersion: 'TAO20260818001',
    srcParam: '1440×1440',
    processMode: '等比缩放',
    outputReq: '1440×1440',
    replacePosition: '主图对应分类',
    conclusion: '处理计划与输出校验通过',
    checkStatus: 'PASSED',
    outputFileNum: 1
  },
  {
    storeName: '天猫二店',
    categoryName: '卖点竖版主图规范',
    type: '竖版主图',
    currentVersion: 'TAO20260818001',
    srcParam: '1440×1920',
    processMode: '等比缩放',
    outputReq: '1440×1920',
    replacePosition: '主图对应分类',
    conclusion: '处理计划与输出校验通过',
    checkStatus: 'PASSED',
    outputFileNum: 1
  },
  {
    storeName: '天猫二店',
    categoryName: '销售属性主图规范',
    type: '销售属性图',
    currentVersion: 'TAO20260818001',
    srcParam: '1600×1600',
    processMode: '等比缩放',
    outputReq: '1600×1600',
    replacePosition: '对应分类',
    conclusion: '处理计划与输出校验通过',
    checkStatus: 'PASSED',
    outputFileNum: 1
  },
  {
    storeName: '天猫二店',
    categoryName: '透明图',
    type: '透明图',
    currentVersion: 'TAO20260818001',
    srcParam: '1600×1600',
    processMode: '等比缩放',
    outputReq: '1600×1600',
    replacePosition: '对应分类',
    conclusion: '处理计划与输出校验通过',
    checkStatus: 'PASSED',
    outputFileNum: 1
  },
  {
    storeName: '天猫二店',
    categoryName: '电脑端切片规范',
    type: '详情页',
    currentVersion: 'TAO20260818001',
    srcParam: '1440×4562',
    processMode: '切分',
    outputReq: '1440×790',
    replacePosition: '详情页',
    conclusion: '处理计划与输出校验通过',
    checkStatus: 'PASSED',
    outputFileNum: 5
  }
]

export default {
  name: 'StoreGoodsImageStepTwo',
  props: {
    rowData: {
      type: Object,
      default: () => ({})
    },
    selectedProductRows: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      exceptionConfirmed: false,
      tableChecked: false,
      loading: false,
      precheckData: {},
      planRows: []
    }
  },
  computed: {
    planStatistics () {
      const rows = Array.isArray(this.planRows) ? this.planRows : []
      return {
        targetNum: rows.length,
        outputNum: rows.reduce((total, item) => total + (Number(item.outputFileNum) || 0), 0),
        frozenNum: rows.filter(item => item.checkStatus === 'BLOCKED').length,
        mapNum: rows.filter(item => item.srcParam).length
      }
    },
    confirmText () {
      if (!this.planRows.length) return '-'
      return this.planRows
        .map((item, index) => `${index + 1}. ${this.displayValue(item.conclusion)}`)
        .join('\n')
    }
  },
  methods: {
    handleExceptionConfirmChange (value) {
      this.$emit('exception-confirm-change', value)
    },
    async handlePrecheck () {
      const spuCodes = this.selectedProductRows
        .map(item => item.platformSpu)
        .filter(Boolean)
      if (!spuCodes.length) {
        this.precheckData = {}
        this.planRows = []
        this.$emit('precheck-change', this.precheckData)
        this.$emit('plan-rows-change', this.planRows)
        this.$message.warning('请先选择商品')
        return
      }
      this.planRows = mockPlanRows
      this.$emit('plan-rows-change', this.planRows)
      return this.planRows
    },
    getResponseData (res) {
      const data = res && res.data
      if (data && data.data) return data.data
      return data || {}
    },
    displayValue (value) {
      return value || value === 0 ? value : '-'
    }
  }
}
</script>

<style lang="stylus" scoped>
.section-block
  margin-bottom 16px

.section-title,
.mini-title
  font-size 14px
  font-weight 600
  color #303133
  margin-bottom 10px

.status-cards
  display grid
  grid-template-columns repeat(4, minmax(0, 1fr))
  gap 12px
  margin-bottom 12px

.status-card
  background #fff
  border 1px solid #ebeef5
  border-radius 6px
  padding 14px

.status-card.warning
  border-color #e6a23c

.status-card.danger
  border-color #f56c6c

.status-card.success
  border-color #67c23a

.card-title
  color #909399
  font-size 12px
  margin-bottom 6px

.card-value
  font-size 24px
  font-weight 600
  color #303133
  margin-bottom 6px

.card-desc
  color #606266
  font-size 12px

.content-grid
  display grid
  grid-template-columns 1fr 1fr
  gap 12px

.content-panel
  background #fff
  border 1px solid #ebeef5
  border-radius 6px
  padding 12px

.confirm-list
  display grid
  grid-template-columns repeat(2, minmax(0, 1fr))
  gap 10px
  margin-bottom 12px

.confirm-item
  background #f7f8fa
  border-radius 6px
  padding 12px

.confirm-label
  display block
  color #909399
  font-size 12px
  margin-bottom 4px

.confirm-value
  color #303133
  font-size 16px
  font-weight 600

.code-box
  white-space pre-line
  word-break break-all
  line-height 1.7
  padding 12px
  background #f7f8fa
  border-radius 6px
  color #606266
  margin-bottom 10px

>>> .el-table__body-wrapper
  overflow auto

@media (max-width: 1200px)
  .status-cards,
  .content-grid,
  .confirm-list
    grid-template-columns 1fr
</style>
